import { Injectable } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';
import { StatusDialogComponent } from './status-dialog/status-dialog.component';
import { Constants } from './constants';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { User, Doctor } from './models';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private tokenSubj: BehaviorSubject<string>;
  public currentToken: Observable<string>;

  private currentInternalSubject: BehaviorSubject<User>;
  public currentInternalUser: Observable<User>;
  doctorList: Doctor[] = [];
  statusDialogReg: MatDialogRef<StatusDialogComponent>;

  constructor(
    public dialog: MatDialog,
    private httpClient: HttpClient
  ) {
    this.currentInternalSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('internallogin')));
    this.currentInternalUser = this.currentInternalSubject.asObservable();

    this.tokenSubj = new BehaviorSubject<string>(JSON.parse(localStorage.getItem('token')));
    this.currentToken = this.tokenSubj.asObservable();
  }

  public get tokenValue() {
    return this.tokenSubj.value;
  }

  public get internalLoginValue() {
    return this.currentInternalSubject.value;
  }

  public setInternalLoginValue(value: User) {
    this.currentInternalSubject.next(value);
  }

  public setTokenValue(value: string) {
    this.tokenSubj.next(value);
  }

  openStatusDialog(statusMessage: string, URL?: string) {
    this.statusDialogReg = this.dialog.open(StatusDialogComponent, {
      disableClose: true
    });
    this.statusDialogReg.componentInstance.statusMessage = statusMessage;
    this.statusDialogReg.componentInstance.navigateToURL = URL;

    this.statusDialogReg.afterClosed().subscribe(result => {
      if (result) {
        // console.log('closed status');
      }
      this.statusDialogReg = null;
    });
  }



  logOut() {
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.LOGOUT_API, {});
  }
  generateInvoice(reqObj: any, checkup_id: string) {
    // reqObj.clinicId = this.doctorValue.clinics[0].clinic._id;
    // reqObj.doctorId = this.doctorValue._id;
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.DOCTOR_API + reqObj.doctorId + Constants.CLINIC_API +
      reqObj.clinicId + Constants.SLASH_CHECKUP_SLASH + checkup_id + Constants.SLASH_INVOICE, reqObj);
  }

  // forgotInternalUser(item: any) {
  //   return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.FORGOT_PASSWORD_API, item);
  // }

  public exportAsExcelFile(json: any[], header: any, excelFileName: string): void {
    const finalArray: string[][] = [header, json];
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    // console.log('worksheet', worksheet);
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    // const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }


  exportTemplateAsExcel(json: any[], header: any) {
    const finalArray: string[][] = [header, json];
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(finalArray);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'test' + '.xlsx');
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
}
